import React from "react"
import PropTypes from "prop-types"
import { Nav, NavItem, NavLink } from "reactstrap"

export const tabsClients = {
  generales: "generales",
  direccionesEntrega: "direcciones-entrega",
  productosAsignados: "productos-asignados",
}

const Tabs = ({ tabActive, setTabActive }) => {
  return (
    <div className="mt-2">
      <Nav tabs>
        <NavItem>
          <NavLink
            style={{ cursor: "pointer" }}
            className={tabActive == tabsClients.generales ? 'active' : ''}
            onClick={() => {
              setTabActive(tabsClients.generales)
            }}
          >
            Datos Generales
          </NavLink>
        </NavItem>
        <NavItem>
          <NavLink
            style={{ cursor: "pointer" }}
            className={tabActive == tabsClients.direccionesEntrega ? 'active' : ''}
            onClick={() => {
              setTabActive(tabsClients.direccionesEntrega)
            }}
          >
            Direcciones de entrega
          </NavLink>
        </NavItem>
        <NavItem>
          <NavLink
            style={{ cursor: "pointer" }}
            className={tabActive == tabsClients.productosAsignados ? 'active' : ''}
            onClick={() => {
              setTabActive(tabsClients.productosAsignados)
            }}
          >
            Productos asignados
          </NavLink>
        </NavItem>
      </Nav>
    </div>
  )
}

Tabs.propTypes = {
  tabActive: PropTypes.string,
  setTabActive: PropTypes.func,
}

export default Tabs
